<template>
  <div class="cancelled-page">
    <div class="cancelled-card">
      <!-- Alert icon -->
      <div class="alert-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>

      <h1 class="heading">Setup not completed</h1>
      <p class="subheading">No worries - it happens!</p>
      <p class="body-text">
        Your subscription setup was cancelled or ran into an issue.<br />
        Your account has not been charged. Please try again when you're ready.
      </p>

      <a href="/" class="retry-button" @click.prevent="tryAgain">
        Try again
      </a>

      <p class="footer-text">
        Need help? Reach us at
        <a href="mailto:hello@lulurewards.co.uk" class="email-link">hello@lulurewards.co.uk</a>
      </p>
    </div>
  </div>
</template>

<script>
import { track } from '@/analytics.js';

export default {
  name: 'SignUpCancelledComponent',
  mounted() {
    track("businessOnboarding_payment_cancelled", {});
  },
  methods: {
    tryAgain() {
      this.$router.push({ path: '/', query: { signup: 'true' } });
    },
  },
};
</script>

<style scoped>
.cancelled-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #fff8f5 0%, #fdf0ec 100%);
  padding: 24px;
}

.cancelled-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 40px rgba(180, 60, 20, 0.1);
  padding: 48px 40px 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.alert-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e05c2a 0%, #c94a1a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(224, 92, 42, 0.35);
  margin-bottom: 24px;
}

.heading {
  font-size: 28px;
  font-weight: 800;
  color: #1a202c;
  margin: 0 0 8px;
  letter-spacing: -0.5px;
}

.subheading {
  font-size: 17px;
  color: #e05c2a;
  font-weight: 600;
  margin: 0 0 16px;
}

.body-text {
  font-size: 14px;
  color: #718096;
  line-height: 1.7;
  margin: 0 0 32px;
}

.retry-button {
  display: inline-block;
  background: linear-gradient(135deg, #e05c2a 0%, #c94a1a 100%);
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  padding: 14px 36px;
  border: none;
  border-radius: 999px;
  margin-bottom: 28px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(224, 92, 42, 0.25);
}

.retry-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(224, 92, 42, 0.35);
}

.footer-text {
  font-size: 12px;
  color: #a0aec0;
  margin: 0;
}

.email-link {
  color: #e05c2a;
  text-decoration: none;
  font-weight: 500;
}

.email-link:hover {
  text-decoration: underline;
}
</style>
